﻿export class LoginModel {
    UserName: string = "";
    Password: string = "";
}

export class ForgotPasswordModel {
    Email: string = "";
}